/**
 * ProfileAvatar Component
 * Displays user profile image with fallback to initials
 */
import React from 'react';
import './ProfileAvatar.css';

interface ProfileAvatarProps {
  src?: string | null;
  username: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const sizeClasses = {
  sm: 'profile-avatar-sm',
  md: 'profile-avatar-md',
  lg: 'profile-avatar-lg',
  xl: 'profile-avatar-xl'
};

export const ProfileAvatar: React.FC<ProfileAvatarProps> = ({
  src,
  username,
  size = 'md',
  className = ''
}) => {
  const getInitials = (name: string): string => {
    const safe = (name || '').trim();
    if (!safe) return '?';
    const parts = safe.split(/\s+/);
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    }
    return safe.slice(0, 2).toUpperCase();
  };

  const containerClass = `profile-avatar ${sizeClasses[size]} ${className}`;

  if (src) {
    return (
      <div className={containerClass}>
        <img
          src={src}
          alt={username}
          className='profile-avatar-img'
        />
      </div>
    );
  }

  return (
    <div className={`${containerClass} profile-avatar-initials`}>
      {getInitials(username)}
    </div>
  );
};
